import { Box } from '@vk-hr-tek/ui/Box';
import { Skeleton } from '@vk-hr-tek/ui/Skeleton';

export const NotificationItemSkeleton = () => {
  return (
    <Box py="8" display="flex" gap="12" alignItems="center">
      <Box display="flex">
        <Skeleton variant="circle" height={48} width={48} />
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        flexDirection="column"
        gap="4"
        width="100%"
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" gap="4" alignItems="center">
            <Skeleton variant="rect" height={16} width={96} />
            <Skeleton variant="rect" height={16} width={96} />
          </Box>
          <Skeleton variant="rect" height={16} width={34} />
        </Box>
        <Box display="flex" gap="4" alignItems="center">
          <Skeleton variant="rect" height={16} width="100%" />
          <Skeleton variant="circle" height={20} width={20} />
        </Box>
      </Box>
    </Box>
  );
};
